import { Flex } from '@teamsparta/stack-flex';
import { Text } from '@teamsparta/stack-text';
import { vars } from '@teamsparta/stack-tokens';

import { Spinner } from '@/components/common/Spinner';

export function Skeleton() {
  return (
    <Flex.Row
      padding='12px 16px'
      align='center'
      gap={10}
      fullWidth
      style={{
        height: 48,
        borderRadius: 8,
        backgroundColor: vars.neutral[90],
        margin: '16px 0',
      }}
    >
      <Spinner />
      <Text
        as='span'
        font={{ mobile: 'bodyM', desktop: 'bodyM' }}
        color={vars.neutral[60]}
      >
        이미지 업로드 중
      </Text>
    </Flex.Row>
  );
}
